import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SpinnerButton from "../spinner-button/spinner-button";

const LeadServicePanelWorkspaceConfigField = ({
  controlId,
  isLoading,
  fieldType,
  fieldLabel,
  fieldValue,
  fieldSetter,
  handleOnSave,
  fieldWidth = "w-50",
  hasClasses = false,
  disabled = false
}) => {
  const { t } = useTranslation();

  const isCheckbox = fieldType === "checkbox";

  return (
    <Form.Group
      controlId={controlId}
      className={`${hasClasses ? "pe-3 border-end border-4" : ""}`}
    >
      <Form.Label>{fieldLabel}</Form.Label>
      <div className="d-flex align-items-center justify-content-between">
        {isCheckbox ? (
          <Form.Check
            type="checkbox"
            checked={fieldValue}
            onChange={({ target: { checked } }) => fieldSetter(checked)}
            disabled={disabled}
          />
        ) : (
          <Form.Control
            type={fieldType}
            className={fieldWidth}
            placeholder={`${t("common.enter")} ${fieldLabel}}`}
            value={fieldValue}
            onChange={({ target: { value } }) => fieldSetter(value)}
            disabled={disabled}
          />
        )}
        {isLoading ? (
          <SpinnerButton btnText={t("common.save")} btnStyle="ms-1" />
        ) : (
          <Button
            className="ms-1"
            disabled={isLoading || disabled}
            onClick={handleOnSave}
          >
            {t("common.save")}
          </Button>
        )}
      </div>
    </Form.Group>
  );
};
export default LeadServicePanelWorkspaceConfigField;
